export default "__VITE_ASSET__jw7ooUeV__"